import EntityChallengeBulkExport from './EntityChallengeBulkExport';

export default EntityChallengeBulkExport;
